/**
* Content Table JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Table component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'content-table',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.toggletip-trigger' ).each( function( index, element ) {
        const trigger = $( element );
        const content = $( element ).attr( 'data-toggletip-content' );

        trigger.on( 'click', function( event ) {
          window.setTimeout( function() {
            trigger.next().empty();
            trigger.next().append( '<span class="">' + content + '</span>' );
            trigger.next().toggleClass( 'is-active' );
          }, 100 );
        } );

        // Remove toggletip on ESC
        trigger.on( 'keydown', function( e ) {
          if ( ( e.keyCode || e.which ) === 27 ) {
            trigger.next().empty();
            trigger.next().removeClass( 'is-active' );
          }
        } );

        // Remove on blur
        trigger.on( 'blur', function( e ) {
          trigger.next().empty();
          trigger.next().removeClass( 'is-active' );
        } );
      } );

      const toggletips = document.querySelectorAll( '[data-toggletip-content]' );

      // Iterate over them
      Array.prototype.forEach.call( toggletips, function( toggletip ) {
        // Get the message from the data-content element
        const message = toggletip.getAttribute( 'data-toggletip-content' );

        // Get the live region element
        const liveRegion = toggletip.nextElementSibling;

        // Toggle the message
        toggletip.addEventListener( 'click', function() {
          liveRegion.innerHTML = '';
          window.setTimeout( function() {
            liveRegion.innerHTML = '<span class="text-xs toggletip"><span class="toggletip-bubble">'+ message +'</span></span>';
          }, 100 );
        } );

        // Close on outside click
        document.addEventListener( 'click', function( e ) {
          if ( toggletip !== e.target ) {
            liveRegion.innerHTML = '';
          }
        } );

        // Remove toggletip on ESC
        toggletip.addEventListener( 'keydown', function( e ) {
          if ( ( e.keyCode || e.which ) === 27 ) {
            liveRegion.innerHTML = '';
          }
        } );

        // Remove on blur
        toggletip.addEventListener( 'blur', function( e ) {
          liveRegion.innerHTML = '';
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-table', COMPONENT );
} )( app );
